import React from "react";

export default function LargeModal(props) {
  console.log(props.product);
  return (
        <>
          <div className="opacity-25 fixed inset-0 z-40 bg-black">
          </div>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-2xl mx-auto font-semibold">
                    Order Details
                  </h3>
                  <button
                    className="p-1 text-black border-0 bg-transparent  float-right text-2xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={()=>props.close()}
                  >
                    X
                  </button>
                </div>
                {/*body*/}
                <div className="grid grid-cols-1 md:grid-cols-2 h-1/2 relative p-6 flex-auto">
                  {/* image of the product to be made. */}
                  <img src={`${props.product.orderItem.image}`} className="w-1/2 md:w-full mx-auto"/>
                  <div className="grid grid-rows-3 h-3/4 md:h-full  ">
                    <div className="h-1/2">
                    <p className="font-semibold">
                      Product Information
                    </p>
                    <p className="">
                      {props.product.orderItem.name.toUpperCase()}
                    </p>
    
                    {/* description of the product or the work */}
    
                    <p>
                      {props.product.Description ? props.product.description:null}
                    </p>
    
    
                    {/* price of the product */}
                    <p>
                    ₹ {props.product.Price}
                    </p>
    
    
                    {/* Expected delivery */}
                    <p>
                      {props.product.createdAt.substring(0,10)}
                    </p>
                    </div>
                    <div>
                    <p className="font-semibold">
                      Buyer Information
                    </p>
                    <p>
                      {props.product.Name}
                    </p>
                    <p>
                      {props.product.email}
                    </p>
                    <p>
                      {props.product.phoneNo}
                    </p>
                    </div>
                    <div>
                        <p className="font-semibold">Order Information</p>
                        <p>{props.product.shippingInfo.address+", "+props.product.shippingInfo.city+", "+props.product.shippingInfo.country+", "+props.product.shippingInfo.state+", zip:"+props.product.shippingInfo.zip}</p>
                      <div className="grid p-2 grid-cols-1 md:grid-cols-2">
                        <a className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 border border-red-700 rounded " href={`mailto:${props.product.email}`}>Mail</a>
                        <a className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 border border-blue-700 rounded " href={`tel:${props.product.shippingInfo.country==="India"&&"+91"}${props.product.phoneNo}`}>Call</a>
                      </div>
                    
                    </div>
                  </div>
              </div>
            </div>
          </div>

        </div>
        </>
  );
}
